<template>
  <div class="wrap-container">
    <el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/smart_lighting' }"
        >智能照明</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/smart_product?typeActive=' + type }"
        >智能产品</el-breadcrumb-item
      >
      <el-breadcrumb-item>产品详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="html-product-detail" v-html="productDetail.details_text"></div>
  </div>
</template>

<script>
import { $comboListDetails } from "../api/index";
export default {
  data() {
    return {
      id: null,
      productDetail: {},
      type: "",
    };
  },
  beforeCreate() {},
  created() {
    this.type = this.$route.query.typeActive;
  },
  beforeMount() {},
  mounted() {
    this.id = this.$route.query.id;
    this.comboListDetails();
  },

  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  components: {},
  methods: {
    comboListDetails() {
      $comboListDetails({ combo_id: this.id }).then((res) => {
        res.data.details_text = res.data.details_text.replaceAll(
          "<video",
          "<video"
        );
        this.productDetail = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-container {
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  min-height: 100vh;
  background-color: #000;

  .bread {
    margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
    margin-left: 10%;
  }
}

// 面包屑
::v-deep {
  .el-breadcrumb__inner {
    font-size: 14px;
    font-weight: 400;
    color: #999999 !important;
    &:hover {
      color: $theme-color !important;
    }
  }
}
.html-product-detail {
  width: 100%;
  color: #fff;
  ::v-deep {
    video,
    img {
      max-width: 100%;
    }
  }
}
</style>
